import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as spinnerActions from '../../actions/spinnerActions';
import {bindActionCreators} from 'redux';
import ContactPersonListRedux from "./ContactPersonListRedux";
import CustomModal from '../../components/CustomModal.jsx';
import BaseList from '../../components/common/list/BaseList.jsx';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import PlaceholderTable from "../common/PlaceholderTable";

class ContactPersonPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'contactPersons';

        this.onClone = this.onClone.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        return [
            this.props.actions.loadContactPersons(this.props.user.company.id)
        ]
    }

    onClone(id) {
        this.props.actions.showSpinner();
        this.props.actions.cloneContactPerson(id)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.contactPersonCloned));
            })
            .catch((err) => {
                this.props.actions.hideSpinner();
            })
    }

    onDelete(id) {
        // user can't delete his account
        if (parseInt(id) === parseInt(this.props.user.id)) {
            toastr.error(this.props.intl.formatMessage(messages.contactPersonErrorDelete));
            return;
        }

        this.idToDelete = id;
        this.props.actions.showContactPersonDeleteModal();
    }

    confirmDelete() {
        if (!this.idToDelete) {
            throw new Error('[idToDelete] property is not defined.');
            return;
        }

        this.props.actions.deleteContactPerson(this.idToDelete).then(() =>
            toastr.success(this.props.intl.formatMessage(messages.contactPersonDeleted)));
        this.props.actions.hideContactPersonDeleteModal();
    }

    render() {
        return (
            <WithResolvedPromises promises={this.actions} preloaderComponent={PlaceholderTable} errorComponent={PlaceholderError}>
                <div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card m-b-20">
                                <div className="card-block">
                                    <ContactPersonListRedux
                                        contactPersons={this.props.contactPersons}
                                        onClone={this.onClone}
                                        onDelete={this.onDelete}
                                        listId={this.listId}
                                        companyId={this.props.user.company.id}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomModal
                        modalTitle={this.props.intl.formatMessage(messages.contactPersonDeleteModalTitle)}
                        modalContent={this.props.intl.formatMessage(messages.contactPersonDeleteQuestion)}
                        confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                        closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                        handleConfirm={this.confirmDelete.bind(this)}
                        handleHideModal={this.props.actions.hideContactPersonDeleteModal}
                        isOpen={this.props.showContactPersonDeleteModal}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

ContactPersonPage.contextTypes = {
    intl: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        contactPersons: state.contactPersons,
        showContactPersonDeleteModal: state.showContactPersonDeleteModal,
        user: state.user,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...contactPersonListActions,
            ...spinnerActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContactPersonPage));


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonPage.jsx